
//contentGroups
//0 - none
//1 - shortContent with userContent
//2 - longContent
//3 - shortContent no userContent
//4 - grammarBubbles

type PageData={
	[key:string]:any
}

export interface PageOptionsMeta{
	optionsId:string, 
	label:string, 
	explain:string,
	options:{optionIndex:number, optionDesc:string}[]
}

export const pageData:PageData={};
pageData.concentration={
	pageDir:'concentration',
	label:'Concentrat...',
	info:'',
	contentGroup:1,
	scoreType:'score'
};
pageData.describer={
	pageDir:'describer',
	label:'Describer',
	info:'',
	contentGroup:3,
	scoreType:'score'
};

pageData.fastEnglish={
	pageDir:'fast-english',
	label:'Fast English',
	info:'',
	contentGroup:1,
	scoreType:'score',
	pageOptionsMeta:[{
		optionsId:'fastMode', 
		label:'Play with countdown timer', 
		explain:"Do you want the game to use the time bar?.",
		options:[
			{optionIndex:0, optionDesc:'No'},
			{optionIndex:1, optionDesc:'Yes'}
		]
	}]
};
pageData.fastVocab={
	pageDir:'fast-vocab',
	label:'Fast Vocab',
	info:'',
	contentGroup:1,
	scoreType:'score'
};
pageData.hangman={
	pageDir:'hangman',
	label:'Hangman',
	info:'',
	contentGroup:1,
	scoreType:'score'
};
pageData.spellingBee={
	pageDir:'spelling-bee',
	label:'Spelling Bee',
	info:'',
	contentGroup:1,
	scoreType:'score',
	pageOptionsMeta:[{
		optionsId:'timerOn', 
		label:'Play with countdown tmer', 
		explain:"",
		options:[
			{optionIndex:0, optionDesc:'No'},
			{optionIndex:1, optionDesc:'Yes'}
		]},{
		optionsId:'easyMode', 
		label:'Easy mode', 
		explain:"Easy mode only shows a maximum of 15 items and is slower.  Hard mode is a maximum of 24 items and is faster.  If 'yes' is selected here, then only 15 items will be shown and the game will be slower.",
		options:[
			{optionIndex:0, optionDesc:'No'},
			{optionIndex:1, optionDesc:'Yes'}
		]}
	]
};
pageData.vocabGame={
	pageDir:'vocab-game',
	label:'Vocab Game',
	info:'',
	contentGroup:1,
	scoreType:'score'
};
pageData.reveal={
	pageDir:'reveal',
	label:'Reveal',
	info:'',
	contentGroup:1,
	scoreType:'score'
};

pageData.bubbles={
	pageDir:'bubbles-english',
	label:'Bubbles',
	info:'',
	contentGroup:2,
	scoreType:'time'
};
pageData.falling={
	pageDir:'falling-english',
	label:'Falling',
	info:'',
	contentGroup:2,
	scoreType:'moves'
};
pageData.fastPhrases={
	pageDir:'fast-phrases',
	label:'Fast Phrases',
	info:'',
	contentGroup:2,
	scoreType:'score'
};

pageData.clothes={
	pageDir:'clothes-game',
	label:'Clothes',
	info:'',
	contentGroup:0,
	scoreType:'score',
	pageOptionsMeta:[{
		optionsId:'timerOn', 
		label:'Play with countdown tmer', 
		explain:"",
		options:[
			{optionIndex:0, optionDesc:'No'},
			{optionIndex:1, optionDesc:'Yes'}
		]}
	]
};
pageData.comparatives={
	pageDir:'comparatives',
	label:'Comparati...',
	info:'',
	contentGroup:0,
	scoreType:'score'
};
pageData.conditionals={
	pageDir:'conditional-sentences',
	label:'Conditionals',
	info:'',
	contentGroup:0,
	scoreType:'score',
	pageOptionsMeta:[{
		optionsId:'fullLength', 
		label:'Include unreal conditionals', 
		explain:"When unreal conditional phrases are included the game length uses 48 different sentences.  When unreal conditionals are excluded the length is reduced to only 24 sentences.",
		options:[
			{optionIndex:0, optionDesc:'No'},
			{optionIndex:1, optionDesc:'Yes'}
		]}
	]
};
pageData.food={
	pageDir:'food',
	label:'Food',
	info:'',
	contentGroup:0,
	scoreType:'score'
};
pageData.future={
	pageDir:'future-tense-game',
	label:'Future Tense',
	info:'',
	contentGroup:0,
	scoreType:'score'
};
pageData.jobs={
	pageDir:'jobs',
	label:'Jobs',
	info:'',
	contentGroup:0,
	scoreType:'score',
	pageOptionsMeta:[{
		optionsId:'difficulty', 
		label:'Choose one', 
		explain:"",
		options:[
			{optionIndex:0, optionDesc:'Easy'},
			{optionIndex:1, optionDesc:'Hard'}
		]}
	]
};

pageData.pastTense={
	pageDir:'past-tense-game',
	label:'Past Tense',
	info:'',
	contentGroup:0,
	scoreType:'score',
	pageOptionsMeta:[{
		optionsId:'timerOn', 
		label:'Play with countdown tmer', 
		explain:"",
		options:[
			{optionIndex:0, optionDesc:'No'},
			{optionIndex:1, optionDesc:'Yes'}
		]},
		{
		optionsId:'reducedLength', 
		label:'Reduced length', 
		explain:"* The Past Tense game is quite long.  Normally it loops through 22 different groups of images.  Choose whether to shortened the game to only include 10 sets of images.",
		options:[
			{optionIndex:0, optionDesc:'22 sets'},
			{optionIndex:1, optionDesc:'10 sets'}
		]}
	]
};

pageData.perfect={
	pageDir:'perfect-tense-game',
	label:'Perfect Ten..',
	info:'',
	contentGroup:0,
	scoreType:'score',
	pageOptionsMeta:[
		{optionsId:'setsToUse' , 
		label:'Sets of content to use', 
		explain:'Choose which sets of images/text to use in the game.  The number of sets will determine the game length.', 
		options:[
			{optionIndex:0, optionDesc:'All (12 sets)'}, 
			{optionIndex:1, optionDesc:'Some (4 sets)'},
			{optionIndex:2, optionDesc:'Sets using the simple form "I have ..." (3 sets)'},
			{optionIndex:3, optionDesc:'Sets in the form "I have ... ... times" (3 sets)'},
			{optionIndex:4, optionDesc:'Sets contrasting "for" and "since" (3 sets)'},
			{optionIndex:5, optionDesc:'Sets constrasting "already", "just" and "yet" (3 sets)'},
		]}
	]
};
pageData.phrasalVerbs={
	pageDir:'phrasal-verbs',
	label:'Phrasals',
	info:'',
	contentGroup:0,
	scoreType:'score'
};
pageData.phraseMaker={
	pageDir:'phrase-maker',
	label:'Phrase maker',
	info:'',
	contentGroup:0,
	scoreType:'score'
};
pageData.prepositions={
	pageDir:'prepositions-game',
	label:'Prepositions',
	info:'',
	contentGroup:0,
	scoreType:'score',
	pageOptionsMeta:[{
		optionsId:'noTimer', 
		label:'Remove timer', 
		explain:"* The Prepositions game can be quite difficult and the time runs down really quickly.  When this option is selected, the count down timer is removed from the game.",
		options:[
			{optionIndex:0, optionDesc:'Keep Timer'},
			{optionIndex:1, optionDesc:'Remove Timer'}
		]}
	]
};
pageData.time={
	pageDir:'telling-the-time',
	label:'Time',
	info:'',
	contentGroup:0,
	scoreType:'score'
};
pageData.weather={
	pageDir:'weather',
	label:'Weather',
	info:'',
	contentGroup:0,
	scoreType:'time'
};

pageData.speakEasy={
	pageDir:'speak-easy',
	label:'Speak Easy',
	info:'',
	contentGroup:0,
	scoreType:'score'
};
pageData.speakingPhrases={
	pageDir:'speaking-phrases',
	label:'Speaking Phrases',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.animalMystery={
	pageDir:'animal-mystery',
	label:'Animal M...',
	info:'',
	contentGroup:0,
	scoreType:'score'
};
pageData.questions={
	pageDir:'questions',
	label:'Questions',
	info:'',
	contentGroup:0,
	scoreType:'score'
};
pageData.monsterPhrases={
	pageDir:'monster-phrases',
	label:'Monster Ph..',
	info:'',
	contentGroup:2,
	scoreType:'score'
};
pageData.presentSimple={
	pageDir:'present-simple',
	label:'Present Sim..',
	info:'',
	contentGroup:0,
	scoreType:'score'
};


pageData.wordSearch={
	pageDir:'wordsearch',
	label:'Word search',
	info:'this page omits items longer than 8 letters',
	contentGroup:1,
	scoreType:'score'
};
pageData.monsterVocab={
	pageDir:'monster-vocab',
	label:'Monster Vo...',
	info:'',
	contentGroup:1,
	scoreType:'score'
};

pageData.numbers={
	pageDir:'numbers',
	label:'Numbers',
	info:'',
	contentGroup:0,
	scoreType:'score',
	pageOptionsMeta:[{
		optionsId:'easyMode', 
		label:'Easy mode', 
		explain:"Easy mode only uses low numbers; all numbers will be under 1000.",
		options:[
			{optionIndex:0, optionDesc:'Hard Mode'},
			{optionIndex:1, optionDesc:'Easy Mode'}
		]}
	]
};

pageData.grammarBubbles={
	pageDir:'grammar-bubbles',
	label:'Grammar B..',
	info:'',
	contentGroup:4,
	scoreType:'score'
};

pageData.daysOfTheWeek={
	pageDir:'days-of-the-week',
	label:'Days',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.family={
	pageDir:'family',
	label:'Family',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.bodyParts={
	pageDir:'body-parts',
	label:'Body Parts',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.monthsGame={
	pageDir:'months-game',
	label:'Months',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.dailyRoutines={
	pageDir:'daily-routines',
	label:'Daily Rou...',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.vocab={
	pageDir:'vocab',
	label:'Vocab',
	info:'',
	contentGroup:1,
	scoreType:'score'
};


pageData.anagrams={
	pageDir:'anagrams',
	label:'Anagrams',
	info:'',
	contentGroup:1,
	scoreType:'score'
};


pageData.adverbs={
	pageDir:'adverbs',
	label:'Adverbs',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.adverbsOfFrequency={
	pageDir:'adverbs-of-frequency',
	label:'Adverbs of F.',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.adjectives={
	pageDir:'adjectives',
	label:'Adjectives',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.fastQuiz={
	pageDir:'fast-quiz',
	label:'Fast Quiz',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.halloween={
	pageDir:'halloween',
	label:'Halloween',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

pageData.christmas={
	pageDir:'christmas',
	label:'Christmas',
	info:'',
	contentGroup:0,
	scoreType:'score'
};

